import { createSlice } from "@reduxjs/toolkit";

const exerciseInitState = {
  isLoading: false,
  exercises: [],
  exercise: {},
  categorys: [],
  primaryVideoUploadState: false,
  primaryVideoUploadProgress: 0,
  primaryVideoKey: null,
  secondaryVideoUploadState: false,
  secondaryVideoUploadProgress: 0,
  secondaryVideoKey: null,
  categories: [],

  options: {
    sets: [],
    reps: [],
    tempos: [],
    cals: [],
    meters: [],
    blockTimings: [],
    workPeriods: [],
    restPeriods: [],
    locations: [],
  },
};

const exercisesReducerSlice = createSlice({
  name: "exercises",
  initialState: exerciseInitState,
  reducers: {
    changeExerciseLoading: (state, action) => {
      if (state.isLoading !== action.payload) {
        state.isLoading = action.payload;
      }
    },
    setExercisePrimaryVideoKey: (state, action) => {
      if (state.primaryVideoKey !== action.payload) {
        state.primaryVideoKey = action.payload;
        state.primaryVideoUploadState = false;
      }
    },
    setExerciseSecondaryVideoKey: (state, action) => {
      if (state.secondaryVideoKey !== action.payload) {
        state.secondaryVideoKey = action.payload;
        state.secondaryVideoUploadState = false;
      }
    },
    changeExercisePrimaryVideoLoading: (state, action) => {
      if (state.primaryVideoUploadState !== action.payload) {
        state.primaryVideoUploadState = action.payload;
      }
    },
    changeExercisePrimaryVideoProgress: (state, action) => {
      if (state.primaryVideoUploadProgress !== action.payload) {
        state.primaryVideoUploadProgress = action.payload;
      }
    },
    changeExerciseSecondaryVideoLoading: (state, action) => {
      if (state.secondaryVideoUploadState !== action.payload) {
        state.secondaryVideoUploadState = action.payload;
      }
    },
    changeExerciseSecondaryVideoProgress: (state, action) => {
      if (state.secondaryVideoUploadProgress !== action.payload) {
        state.secondaryVideoUploadProgress = action.payload;
      }
    },
    setPrimaryVideoProgressState: (state, action) => {
      state.primaryVideoUploadProgress = action.payload.progress ?? 0;
      state.primaryVideoUploadState = action.payload.uploadState ?? false;
      state.primaryVideoKey = action.payload.videoKey ?? null;
    },
    setSecondaryVideoProgressState: (state, action) => {
      state.secondaryVideoUploadProgress = action.payload.progress ?? 0;
      state.secondaryVideoUploadState = action.payload.uploadState ?? false;
      state.secondaryVideoKey = action.payload.videoKey ?? null;
    },
    setExerciseState: (state, action) => {
      state.exercises = action.payload.exercises || state.exercises;
      state.isLoading = false;
    },
    setCategoryState: (state, action) => {
      state.categories = action.payload.categories || state.categories;
      state.isLoading = false;
    },
    setExerciseOptionState: (state, action) => {
      state.options = action.payload.options || state.options;
      state.isLoading = false;
    },
    addExerciseState: (state, action) => {
      state.exercises.unshift(action.payload);
      state.isLoading = false;
    },
    setExerciseById: (state, action) => {
      state.exercise = action.payload;
      state.isLoading = false;
    },
    editExerciseState: (state, action) => {
      state.exercises = state.exercises.map((exercise) => {
        if (action.payload._id === exercise._id) {
          exercise = action.payload;
        }
        return exercise;
      });
      state.isLoading = false;
    },
    deleteExerciseState: (state, action) => {
      state.exercises = state.exercises.filter(
        (exercise) => exercise._id !== action.payload
      );
      state.isLoading = false;
    },
  },
});

export const {
  changeExerciseLoading,
  changeExercisePrimaryVideoLoading,
  changeExercisePrimaryVideoProgress,
  changeExerciseSecondaryVideoLoading,
  changeExerciseSecondaryVideoProgress,
  setExercisePrimaryVideoKey,
  setExerciseSecondaryVideoKey,
  setPrimaryVideoProgressState,setSecondaryVideoProgressState,
  addExerciseState,
  deleteExerciseState,
  setCategoryState,
  setExerciseState,
  setExerciseById,
  editExerciseState,
  setExerciseOptionState,
} = exercisesReducerSlice.actions;

export default exercisesReducerSlice.reducer;
